const enumUserRole = {
  ADMIN: 1,
  ACCESS_ORG_LEVEL: 2,
  ACCESS_BRANCH_LEVEL: 3,
  ACCESS_UNIT_LEVEL: 4,
  ACCESS_DEPARTMENT_LEVEL: 5,
};

export default enumUserRole;
